export const onUpdateGridHandler = (data, added, changed, deleted) => {
    let updated = [...data]
    if (changed) {
        for(const key in changed) {
            updated[key] = {...updated[key], ...changed[key]}
        }
    }
    if (deleted) {
        updated = updated.filter((x, i)=>!deleted.includes(i))
    }
    if (added){
        updated = [...updated, ...added]
    }
    return updated
}

// ============================================
// Excel Export Utilities
// ============================================

// Default styles
export const excelStyles = {
    title: { bold: true, size: 16 },
    section: { bold: true, size: 12 },
    header: { bold: true, size: 10 },
};

// Convert column number to letter (1=A, 27=AA, etc.)
const getColumnLetter = (num) => {
    let result = '';
    while (num > 0) {
        result = String.fromCharCode(65 + (num - 1) % 26) + result;
        num = Math.floor((num - 1) / 26);
    }
    return result;
};

/**
 * Add a title row to Excel worksheet with merge and styling.
 * Skips if worksheet already has content (handles React StrictMode double-render).
 * Use createExcelHeader() for simple cases, use this directly when you need more control.
 *
 * @param {object} worksheet - ExcelJS worksheet
 * @param {string} title - Title text
 * @param {object} [options] - Optional settings
 * @param {number} [options.numColumns=15] - Columns to merge
 * @param {object} [options.font=excelStyles.title] - Font style
 */
export const addExcelTitleRow = (worksheet, title, options = {}) => {
    const { numColumns = 15, font = excelStyles.title } = options;

    // Native ExcelJS: skip if worksheet already has rows
    if (worksheet.actualRowCount > 0) return null;

    const row = worksheet.addRow([title]);
    worksheet.mergeCells(`A${row.number}:${getColumnLetter(numColumns)}${row.number}`);
    row.height = 20;
    row.font = font;
    row.alignment = { vertical: 'middle', horizontal: 'center' };
    return row;
};

/**
 * Creates a customizeExcelHeader function for GridExporter.
 *
 * @param {string} title - Title text to display
 * @param {object} [options] - Optional settings
 * @param {number} [options.numColumns=15] - Columns to merge
 * @param {object} [options.font=excelStyles.title] - Font style
 * @returns {function} customizeHeader function for excel options
 *
 * @example
 * // Standard usage (recommended)
 * excel: { customizeHeader: createExcelHeader(`Report Title`) }
 *
 * // With options
 * excel: { customizeHeader: createExcelHeader(`Report Title`, { numColumns: 10 }) }
 * excel: { customizeHeader: createExcelHeader(`Report Title`, { font: { bold: true, size: 20 } }) }
 */
export const createExcelHeader = (title, options = {}) => {
    return (worksheet) => {
        addExcelTitleRow(worksheet, title, options);
    };
};
